const api = window.location.host.indexOf('localhost:') === 0 ? 'https://wedlinycrm.devsafi.pl/' : (window.location.origin + '/');

export default api;
